import { useEffect } from "react";

export function useBootstrapDirection(lang, { i18n }) {
    useEffect(() => {
        document.documentElement.lang = lang;
        document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
        const linkElement = document.getElementById("bootstrap-dynamic-css");
        if (linkElement) {
            linkElement.href = lang === "ar"
                ? "https://cdnjs.cloudflare.com/ajax/libs/bootstrap/5.3.8/css/bootstrap.rtl.min.css"
                : "https://cdn.jsdelivr.net/npm/bootstrap@5.3.8/dist/css/bootstrap.min.css";
            linkElement.integrity = lang === "ar"
                ? "sha512-4W9f7EnJgM33kD11Ux2XNF9DSpJ7LoQXCvBNhzKTorRSyjPHmjXhHMZMafIYqYvTNWahUk2ulNsarMMLDEv4zA=="
                : "sha384-sRIl4kxILFvY47J16cr9ZwB07vP4J8+LH7qKQnuqkuIAvNWLzeN8tE5YBujZqJLB";
        }
        // If the current route includes AdminLayout, force language to Arabic
        if (window.location.pathname.startsWith("/admin") || window.location.pathname.startsWith("/adminLogin")) {
            if (lang !== "ar") {
                document.documentElement.lang = "ar";
                document.documentElement.dir = "rtl";
                i18n.changeLanguage("ar");
            }
        }
    }, [lang, i18n]);
}